"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTripStatusesInput = exports.GetTripStatusesInput = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_transformers_1 = require("@daytrip/legacy-transformers");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class GetTripStatusesInput {
    constructor() {
        this.departureDateMode = legacy_enums_1.DepartureDateMode.DEFAULT;
    }
}
exports.GetTripStatusesInput = GetTripStatusesInput;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_transformer_1.Transform)(({ value }) => {
        if (!value) {
            return undefined;
        }
        if (typeof value === "string") {
            return [value];
        }
        if (Array.isArray(value)) {
            return value;
        }
        return undefined;
    }),
    __metadata("design:type", Array)
], GetTripStatusesInput.prototype, "originCountryIdIn", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsIn)([1, -1]),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Number)
], GetTripStatusesInput.prototype, "sortByDeparture", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.TripTrackingStatus, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => {
        if (!value) {
            return undefined;
        }
        if (typeof value === "string") {
            return [value];
        }
        if (Array.isArray(value)) {
            return value;
        }
        return undefined;
    }),
    __metadata("design:type", Array)
], GetTripStatusesInput.prototype, "trackingStatusIn", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], GetTripStatusesInput.prototype, "departureFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], GetTripStatusesInput.prototype, "departureTo", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.DepartureDateMode),
    __metadata("design:type", String)
], GetTripStatusesInput.prototype, "departureDateMode", void 0);
class ListTripStatusesInput extends GetTripStatusesInput {
}
exports.ListTripStatusesInput = ListTripStatusesInput;
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ListTripStatusesInput.prototype, "limit", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ListTripStatusesInput.prototype, "skip", void 0);
//# sourceMappingURL=list-trip-statuses-input.js.map